﻿import * as React from "react";

export const Filler: React.FunctionComponent = (): React.ReactElement => (
    <div className={`filler`} />
);
